import { defineAsyncComponent } from 'vue';
import type { Account } from '@/widgets/Wizard/models/accounts';
import {
    tacozijlConfig,
    defaultConfig,
    campingLaPinedeConfig,
    uiterwaardeConfig,
} from '@/widgets/Wizard/configs';

export default [
    {
        code: 'campingLaPinede',
        hosts: ['camping-la-pinede.boekenzuil.3wstaging.nl'],
        tommy: {
            version: 3,
            url: import.meta.env.VITE_WIZARD_TOMMY3_API,
        },
        config: campingLaPinedeConfig,
        wrapper: undefined,
        information: {
            parkName: 'Camping La Pinede',
            website: 'www.campinglapinede.lu',
            websiteURL: 'https://www.campinglapinede.lu/',
            phoneNumber: '+352 62 14 36 177',
        },
        options: {
            tokens: {
                tommy3: {
                    operational: '1897-ef560c6c73ed791d9cb5daa3d807d3cb797d7098b56a690344131284514c10e9ea5a2efdf5fe2a72d28d4f02a4eaf8bfd5ffccba893d2ad6963de163d9bec718',
                    widget: '1897-3734df729ea4a631ff496f89bafaa378419def6f95a4b16b645b5231213cbf90db294734735b8fa9e6c30a413bf266eddd6b28002d2b2f684a439e248cf7f54d',
                },
            },
            salesChannel: 56145,
            pets: undefined,
            usePin: true,
            useMap: true,
            useTimeTable: false,
            useTimeTableWizardOptions: false,
            useAccommodationPreviewList: false,
            useEuropeanCountryPrioritySort: false,
            usesProgressBar: true,
        },
    },
    {
        code: 'default',
        hosts: [],
        tommy: {
            version: 3,
            url: import.meta.env.VITE_WIZARD_TOMMY3_API_ACCEPTANCE,
        },
        config: defaultConfig,
        wrapper: undefined,
        information: {
            parkName: 'Default boekenzuil',
            website: 'example.com',
            websiteURL: 'https://example.com/',
            phoneNumber: '+31 6 123456789',
        },
        options: {
            tokens: {
                tommy3: {
                    // Reestland tokens
                    operational:
                        '5327-c0fbb13d849f328c3b9cd60a833c6ec2907f5f1d9c24d30fd133f84db2ae4f99e182dd9f937a111bafa9517f20c3383459d44941eae1b686ed557ee044b9a436',
                    widget: '5327-af005f8b7a44171206c54434ffed0b8cc1b7b70605392848dc55ec44685c292e547b4184abd92a706262fef89746495318112464987b264ad6f0c4393f4efcd2',
                },
            },
            salesChannel: undefined,
            pets: undefined,
            usePin: true,
            useMap: false,
            useTimeTable: false,
            useTimeTableWizardOptions: false,
            useAccommodationPreviewList: true,
            useEuropeanCountryPrioritySort: false,
            usesProgressBar: true,
        },
    },
    {
        code: 'tacozijl',
        hosts: ['tacozijl.boekenzuil.3wstaging.nl'],
        tommy: {
            version: 3,
            url: import.meta.env.VITE_WIZARD_TOMMY3_API_ACCEPTANCE,
        },
        config: tacozijlConfig,
        wrapper: undefined,
        information: {
            parkName: 'Tacozijl',
            website: 'tacozijl.nl',
            websiteURL: 'https://tacozijl.nl/',
            phoneNumber: '+31 514 562 003',
        },
        options: {
            tokens: {
                tommy3: {
                    operational:
                        '4320-26f68942d2ea9dd49edb47e548b9ca98023b64de73aa0527be4b7da1c6bc3cc3e32c363460e3dafe9c306e5714bb956b58e789aa6c55f28162eb0b463360b8b4',
                    widget: '4320-963a386168138db67350a31427b1a10b3500fd9c87c2c50152755788b6a7c6dc5f125519b5ac6ef8c66898654fa1eba26973cc3cc737f128bb8bed50bc2c5c84',
                },
            },
            pets: undefined,
            salesChannel: 55857,
            usePin: true,
            useMap: true,
            useTimeTable: false,
            useTimeTableWizardOptions: false,
            useAccommodationPreviewList: true,
            useEuropeanCountryPrioritySort: false,
            usesProgressBar: true,
        },
    },
    {
        code: 'uiterwaarde',
        hosts: ['uiterwaarde.boekenzuil.3wstaging.nl', 'localhost'],
        tommy: {
            version: 3,
            url: import.meta.env.VITE_WIZARD_TOMMY3_API,
        },
        config: uiterwaardeConfig,
        information: {
            parkName: 'Uiterwaarde',
            website: 'tacozijl.nl',
            websiteURL: 'https://www.uiterwaarde.nl//',
            phoneNumber: '0344 - 68 16 44',
        },
        wrapper: defineAsyncComponent(
            () => import('@/widgets/Wizard/components-override/uiterwaarde/wrapper.vue'),
        ),
        options: {
            tokens: {
                tommy3: {
                    // Prod tokens
                    operational: '6738-424b6d230a9fbc805250934ddf7629d92e6412d258aa28685ed2b6d1f862a4c316b87a9d24d1fb88b3a79876a2cb3c1bf5c2561aeffcc8a4e66d9ad9374dd9a7',
                    widget: '6738-77e653404698da559a3259f382768b93cd4e660e0039f3eccc602eb57ab71b10a2d6f533a84fdd43fb2734b1b85d9d55b5e512584937152f81256fbfadcd2441',

                    // Acceptance tokens:
                    // operational: '2632-c6951cf76baf3e82e4334d5440cb23f224410b00e36bc3bb9826765381faf7cb909cb194f149ced75dcf9628f7802efb3b761ff2406b28ba57a952a493eee369',
                    // widget: '2632-cf042a94ea8e2545c3e1c8f7b3a471fc809f4b7604eeb3edd8791060f4a77880ebe049fc80a3b6e2fd0eccaddcf19be9bae44c071964da630adbce056f977c60',
                },
            },
            pets: undefined,
            salesChannel: 56793,
            usePin: false,
            useMap: false,
            useTimeTable: false,
            useTimeTableWizardOptions: false,
            useAccommodationPreviewList: false,
            useEuropeanCountryPrioritySort: false,
            usesProgressBar: false,
            showNavigationGuide: false,
            defaultLocale: 'nl',
            arrangementFormDefaults: {
                'license-plate': true,
            },
            arrangementFormConfig: {
                // https://www.uiterwaarde.nl/parkeerabonnementen/
                // Jaarabonnemnet
                '624744': {
                    'license-plate2': true,
                },
                // Zomerabonnement
                '630577': {
                    'license-plate2': true,
                },
                // Langeland
                '624747': {
                    'license-plate2': false,
                },
                // Winterabonnement
                '630574': {
                    'license-plate2': false,
                },
            },
        },
    },
] as Account[];
